export default __webpack_public_path__ + "static/media/true-skate.0b931d81.webp";